export const arrayToQuery = (arr?: string[]) =>
  arr && arr.length > 0 ? arr.join(",") : "";

export const queryToArray = (value?: string | null) =>
  value ? value.split(",").filter(Boolean) : [];
